import { TaskEstimateSuppliedValueType } from 'types'

export const isNullTaskEstimate = (
  taskEstimate: TaskEstimate,
): taskEstimate is NullTaskEstimate =>
  taskEstimate.suppliedValueType === TaskEstimateSuppliedValueType.NULL
